import { inject, observer } from 'mobx-react';
export default function withStores() {
    var stores = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        stores[_i] = arguments[_i];
    }
    return (function (component) { return inject.apply(void 0, stores)(observer(component)); });
}
